const parseHostName = (value?: string | null) => {
  const normalized = (value || '').trim()

  if (!normalized) {
    return ''
  }

  try {
    return new URL(normalized).hostname.toLowerCase()
  } catch {
    return normalized
      .replace(/^https?:\/\//i, '')
      .replace(/\/.*$/, '')
      .toLowerCase()
  }
}

const readAliasHosts = (value?: string | null) =>
  `${value || ''}`
    .split(',')
    .map((item) => parseHostName(item))
    .filter(Boolean)

export const getKnownAdminHosts = () => {
  const hosts = new Set(['localhost', '127.0.0.1'])

  const configuredHost = parseHostName(process.env.REACT_APP_ADMIN_SITE_URL)
  if (configuredHost) {
    hosts.add(configuredHost)
  }

  for (const aliasHost of readAliasHosts(
    process.env.REACT_APP_ADMIN_HOST_ALIASES
  )) {
    hosts.add(aliasHost)
  }

  return hosts
}
